// extracted by mini-css-extract-plugin
module.exports = {"outer-container":"gridShelf__outer-container___yXMEV","inner-container":"gridShelf__inner-container___aZSJz"};